import styled from "@emotion/styled"
import Link from "components/Link"

const ListTenItemLink = styled(Link)`
  font-weight: 500;
  font-size: 18px;
  line-height: 38px;
  color: ${({ theme }) => theme.palette.primary.main};
  text-decoration: none;
  letter-spacing: 0.06em;
  border-bottom: 1px solid transparent;
  transition: all 0.2s;
  margin-bottom: -1px;
  max-width: max-content;
  width: 100%;

  &:hover {
    border-color: ${({ theme }) => theme.palette.primary.main};
  }
`

export default ListTenItemLink
